module.exports = __webpack_public_path__ + "static/media/guest-ready-screen.aef3aa4f.svg";